<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ADMIN_ROLE } from '@utils/constant'
import { ErrorWrapper } from '@utils/error-handler'
import {
  courseComputed,
  courseListMethod,
  authComputed,
  meetingListMethod,
} from '@state/helpers'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import swal from 'sweetalert'
export default {
  page: {
    title: 'Calendar',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, FullCalendar: FullCalendar },
  data() {
    return {
      ADMIN_ROLE: ADMIN_ROLE,
      isLoading: true,
      display: false,
      calendarOptions: {},
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          colType: 'default',
        },
        {
          key: 'category.name',
          label: 'Category',
          sortable: true,
          colType: 'default',
        },
        {
          key: 'subcategory.name',
          label: 'Sub Category',
          sortable: true,
          colType: 'default',
        },
        {
          key: 'detailAction',
          label: 'session',
          sortable: false,
          colType: 'detailAction',
        },
        { key: 'rating', label: 'Rating', sortable: true, colType: 'default' },
        { key: 'action', title: 'Action', sortable: false, colType: 'button' },
      ],
      displayFields: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'features', label: 'Features', colType: 'list' },
        { key: 'topics', label: 'Topics', colType: 'list' },
        { key: 'description', label: 'Description', colType: 'html' },
        { key: 'overview', label: 'Overview', colType: 'html' },
        {
          key: 'career_opportunity',
          label: 'Career Opportunity',
          colType: 'html',
        },
        { key: 'career_salary', label: 'Career Salary', colType: 'html' },
        { key: 'rating', label: 'Rating', colType: 'default' },
        { key: 'duration', label: 'Duration', colType: 'default' },
        { key: 'createdAt', label: 'Published On ', colType: 'date' },
      ],
      eventType: null,
      events: [
        { text: 'Select Event Type', value: null, disabled: 'true' },
        'event',
        'holiday',
        'exam',
      ],
    }
  },
  computed: {
    ...courseComputed,
    ...authComputed,
  },
  mounted() {
    this.calendarOptions = {}
    this.getListOfCalendarEvents()
    this.initializeCalendar()
  },
  methods: {
    ...courseListMethod,
    ...meetingListMethod,
    initializeCalendar() {
      this.calendarOptions = {
        plugins: [dayGridPlugin, interactionPlugin],
        dayMaxEvents: 3,
        initialView: 'dayGridMonth',
        headerToolbar: {
          end: 'today prev,next dayGridMonth dayGridWeek prevYear,nextYear',
        },
        displayEventEnd: true,
        eventClick: this.eventClick,
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: true,
        },
      }
    },
    eventClick: function (info) {
      if (info.event.end !== null) {
        info.event.description =
          'Event Name: ' +
          info.event.title +
          '\nDate: ' +
          moment(info.event.start).format('DD MMM YYYY') +
          '-' +
          moment(info.event.end).format('DD MMM YYYY') +
          '\nTime: ' +
          moment(info.event.start).format('hh:mm a') +
          '-' +
          moment(info.event.end).format('hh:mm a')
        swal(info.event.description)
      } else {
        info.event.description =
          'Class Title: ' +
          info.event.title +
          '\nDate: ' +
          moment(info.event.start).format('DD MMM YYYY') +
          '\nTime: ' +
          moment(info.event.start).format('hh:mm a')
        swal(info.event.description)
      }
    },

    // Get list of all courses role wise
    getListOfCalendarEvents() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCalendarEventList({ filter })
        .then((calendarEventList) => {
          this.calendarOptions.events = JSON.parse(
            JSON.stringify(this.calendarEventList.docs)
          )
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
      this.getListOfMeeting()
    },

    getListOfMeeting() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'date',
        order: '1',
      }
      this.fetchMeetingList({ filter })
        .then((meetingList) => {
          let i = 0
          let length = this.calendarOptions.events.length
          for (i = 0; i < meetingList.docs.length; i++) {
            this.calendarOptions.events[length + i] = {
              start: moment(
                `${meetingList.docs[i].date} ${meetingList.docs[i].start_time}`,
                'YYYY-MM-DD HH:mm:ss'
              ).format(),
              end: moment(
                `${meetingList.docs[i].date} ${meetingList.docs[i].end_time}`,
                'YYYY-MM-DD HH:mm:ss'
              ).format(),
              title: meetingList.docs[i].title,
            }
          }
          this.isLoading = false
          this.display = true
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },

    getEvents() {
      this.isLoading = true
      let newList = {}
      newList = this.calendarEventList.docs.filter((event) => {
        return event.type === this.eventType
      })
      this.isLoading = false
      this.initializeCalendar()
      this.calendarOptions.events = newList
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="isLoading" :opacity="0.6" rounded="sm">
          <b-card>
            <router-link
              tag="button"
              to="/calendar-event-add"
              class="btn btn-info mb-2"
            >
              <i class="ti-plus"></i><span> Add Event</span> </router-link
            >&nbsp;
            <router-link
              tag="button"
              to="/calendar-event"
              class="btn btn-info mb-2"
            >
              <i class="ti-eye"></i><span>&nbsp;View Calendar Event List</span>
            </router-link>
            <b-form-group
              class="col-md-6 p-0"
              label="Filter By Event Type"
              label-for="input-1"
            >
              <b-form-select
                v-model="eventType"
                :options="events"
                @change="getEvents"
              ></b-form-select>
            </b-form-group>
            <div v-if="display">
              <FullCalendar :options="calendarOptions"></FullCalendar>
            </div>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
